import { createStore } from "vuex";

export default createStore({
  state: {
    isRefresh: "true",
  },
  getters: {
    isRefresh: (state) => state.isRefresh,
  },
  mutations: {
    changeRefresh: (state, isRefresh) => {
      //此处必须传入一个state，后面是调用传入的值
      state.isRefresh = isRefresh;
    },
  },
  actions: {},
  modules: {},
});
